import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromRoles from '@roles/store/roles.reducer';
import { LoadRoles } from '@roles/store/roles.actions';
import { Observable } from 'rxjs';
import { IRole } from '@roles/models/IRole';

@Component({
  selector: 'app-roles-page',
  templateUrl: './roles-page.component.html',
  styleUrls: ['./roles-page.component.scss'],
})
export class RolesPageComponent implements OnInit {
  userRoles$: Observable<string[]> = this.store.pipe(
    select(fromRoles.getUserRolesArray),
  );
  getAllBOPermissions$: Observable<any> = this.store.pipe(
    select(fromRoles.getAllBOPermissions),
  );
  getAllOnePermissions$: Observable<any> = this.store.pipe(
    select(fromRoles.getAllOnePermissions),
  );
  accountUserRoles$: Observable<string[]> = this.store.pipe(
    select(fromRoles.getAccountUserRolesArray),
  );
  rolesPermissions$: Observable<IRole> = this.store.pipe(
    select(fromRoles.getRolesPermissions),
  );
  isLoading$: Observable<boolean> = this.store.pipe(
    select(fromRoles.getIsLoadingRoles),
  );

  constructor(private store: Store<fromRoles.RolesState>) {}

  ngOnInit() {
    this.store.dispatch(new LoadRoles());
  }
}
